import { libsMap, serviceHost } from '../enums/libs-map';

const loadMap: { [key: string]: any } = {}; // 资源已加载清单
/**
 * 加载cndjs库
 * 挂载在window上，可通过window.getScript(libName)
 * @export
 * @param {*} libName libs-map.ts中的js库名
 * @param {any} trueDocument 真实的document，在微应用的时候，需要传入container
 * @param {any} trueBody 真实的body
 * @returns
 */
export function getScript(libName: string, trueDocument = document, trueBody = document.body) {
  if (libName === 'amap') {
    return getAMapScript(libName);
  }
  if (!libName) {
    return;
  }
  if (!loadMap[libName]) {
    loadMap[libName] = new Promise((resolve, reject) => {
      const libSrc = libsMap[libName];
      if (!libSrc) {
        reject(`lib '${libName}' not defined`);
        return;
      }
      const script = trueDocument.createElement('script');
      script.src = libSrc;
      script.onload = () => {
        trueBody.removeChild(script);
        resolve(undefined);
      };
      script.onerror = () => {
        trueBody.removeChild(script);
        reject();
      };
      trueBody.appendChild(script);
    });
  }
  return loadMap[libName];
}

/**
 * 加载高德地图
 * 其中高德地图有部分代码是异步执行的，如加载plugins（AMap.Map、AMap.IndoorMap），如果没加载完就使用，会报错；
 * 这里通过高德地图提供的 callback 触发 resovel()，以确保地图所有内容加载完成
 * 挂载在Vue上，可通过this.$getScript(libName)
 * @export
 * @param {*} libName libsMap.js中的js库名
 * @returns
 */
function getAMapScript(libName) {
  if (!loadMap[libName]) {
    loadMap[libName] = new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      const libSrc = libsMap[libName];
      if (!libSrc) {
        reject(`lib '${libName}' not defined`);
        return;
      }
      // 覆盖 window.amapInit，使其能够通过 callback=amapInit 回调触发resolve
      window.amapInit = () => {
        resolve();
      };

      // 高德地图自2021年12月02日升级，升级之后所申请的 key 必须配备安全密钥 jscode 一起使用
      // 需要在加载之前设置（即在 script.onload 之前）
      serviceHost && (window._AMapSecurityConfig = { serviceHost });

      script.src = libSrc;
      script.onload = () => {
        document.body.removeChild(script);
      };
      script.onerror = () => {
        document.body.removeChild(script);
        reject();
        return;
      };
      document.body.appendChild(script);
    });
  }
  return loadMap[libName];
}
